import { Box, Button, CardActions, CardContent, CardHeader, Dialog, DialogActions, DialogTitle, Divider, Grid, MobileStepper, Modal, Paper, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DatosGenerales from './formulario/DatosGenerales';
import AntecedentesOrganismo from './formularioOrganismo/AntecedentesOrganismo';
import ObjetivosOrganismo from './formularioOrganismo/ObjetivosOrganismo';
import FuncionesOrganismo from './formularioOrganismo/FuncionesOrganismo';
import ActividadesOrganismo from './formularioOrganismo/ActividadesOrganismo';
import DatosPublicador from './formulario/DatosPublicador';

import { useNavigate } from 'react-router-dom';
import { validarEmail, validarTelefono } from '../lib/validate';
import toast from 'react-hot-toast';
import { CheckCircle, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import SociosOrganismo from './formularioOrganismo/SociosOrganismo';

const AgregarOrganismo = () => {
    const [paso, setPaso] = useState(0);
    const navigate = useNavigate();
    const [terminos, setTerminos] = useState(false);
    const [datosFormulario, setDatosFormulario] = useState({
        datos_generales: {
            nombre_empresa: '',
            nombre_comercial: '',
            descripcion: '',
            acronimo_empresa: '',
            figura_juridica: '',
            figura_juridica_otro: '',
            nombre_contacto: '',
            logotipo: '',  // File
            galeria: '', // array de Files
            // domicilio
            calle: '',
            numero_ext: '',
            numero_int: '',
            localidad: '',
            municipio: '',
            estado: '',
            codigo_postal: '',
            geolocalizacion: '',
            telefono: '',
            whatsapp: '',
            email: '',
            pagina_web: '',
            facebook: '',
            instagram: '',
            tiktok: '',
            x_twitter: '',
            url_tienda: '',

        },
        total_socios: {
            socios: [
                {
                    figura_juridica: '',
                    n_empresas: '', // empresas u organizaciones sociales
                    n_personas: '' // personas asociadas
                }
            ],
            imagenes: [] // File, max 20
        },
        antecedentes: {
            fecha_lugar: '',
            origen: '',
            imagenes: [], // File, max 3: Primeras sesiones del organismo
            year_inicio: null,
            socios_origen: {
                n_empresas: 0,
                n_organizaciones: 0,
                total_socios: 0
            }
        },
        objetivos: {
            propositos: '',
            factores: [], // Factores que han favorecido el desarrollo de la organizacion
            organizaciones: [], // org o programas que han contribuido
            resultados: [], // socioeconomicos y ambientales 
            perspectivas: [] // perspectivas y beneficios posibles
        },
        funciones_servicios: {
            actividades: [
                {
                    nombre: '',
                    n_empresas: '',
                    n_socios: '',

                }
            ],
            imagenes: [] // files max 2 por indice
        },
        actividades_economicas: {
            actividades: [
                {
                    giro: '', // catalogo actividad economica
                }
            ],
            imagenes: [] // Files max 7
        },
        datos_publicador: {
            nombre: '',
            organizacion: '',
            email: '',
            telefono: '',
            whatsapp: '',
        }
    });
    const [errores, setErrores] = useState([]);
    // funcion para actualizar el estado datosFormulario
    /**
     * 
     * @param {*} e 
     * @param {boolean} imagen 
     */
    const setDatos = (e, imagen = null) => {
        let step = steps.filter((s) => s.id === paso);
        step = step[0].name;
        if (imagen) {
            setDatosFormulario({ ...datosFormulario, [step]: { ...datosFormulario[step], [e.target.name]: imagen } });
        } else {
            setDatosFormulario({ ...datosFormulario, [step]: { ...datosFormulario[step], [e.target.name]: e.target.value } });
        }
    }

    const construirFormData = (formData, datos, clavePadre = '') => {
        Object.keys(datos).forEach((clave) => {
            const claveCompleta = clavePadre ? `${clavePadre}[${clave}]` : clave;
            if (Array.isArray(datos[clave])) {
                datos[clave].forEach((item, index) => {
                    if (Array.isArray(item) && item[0] instanceof File) {
                        // Si es un array de arrays con objetos File, agrega cada elemento al FormData
                        item.forEach((file, subIndex) => {
                            formData.append(`${claveCompleta}[${index}][${subIndex}]`, file);
                        });
                    } else if (item instanceof File) {
                        // Si es un objeto File, agrega al FormData
                        formData.append(`${claveCompleta}[${index}]`, item);
                    } else {
                        // Si es un array no File o cualquier otra cosa, llama recursivamente
                        construirFormData(formData, { [clave]: item }, `${claveCompleta}[${index}]`);
                    }
                });
            } else if (typeof datos[clave] === 'object' && datos[clave] !== null) {
                // Si es un objeto, llama recursivamente
                construirFormData(formData, datos[clave], claveCompleta);
            } else {
                if (claveCompleta.includes("logotipo")) {
                    formData.append('datos_generales[logotipo]', datos);
                } else {
                    // Tratamiento directo para cualquier otra propiedad (incluyendo imágenes individuales)
                    formData.append(claveCompleta, datos[clave]);
                }
            }
        });
    };


    const validar = () => {
        let validated = true;
        let message = [];
        let errs;

        switch (paso) {
            case 0: // Validar "datos_generales"
                errs = Object.keys(datosFormulario.datos_generales).map((label) => {
                    let valor;
                    switch (label) {
                        case 'nombre_empresa': case 'acronimo_empresa':
                        case 'figura_juridica': case 'nombre_contacto':
                        case 'calle': case 'numero_ext':
                        case 'codigo_postal': case 'localidad':
                        case 'municipio': case 'estado':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || ['', undefined, null].includes(valor)) {
                                validated = false;
                                message.push('Favor de llenar los campos obligatorios (*).');
                                return label;
                            }
                            break;
                        case 'email':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || !validarEmail(valor)) {
                                validated = false;
                                message.push('Por favor, ingresa un correo electrónico válido.');
                                return label;
                            }
                            break;
                        case 'telefono':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || !validarTelefono(valor) || valor.length < 10 || isNaN(Number(valor))) {
                                validated = false;
                                message.push('Formato de teléfono incorrecto.');
                                return label;
                            }
                            break;
                        case 'logotipo':
                            if (!(datosFormulario.datos_generales.logotipo instanceof File)) {
                                validated = false;
                                message.push('Es necesario agregar un logotipo.');
                                return label;
                            }
                            break;
                        case 'galeria':
                            if (datosFormulario.datos_generales.galeria.length < 1) {
                                message.push('Debe haber al menos una imagen en la galería.');
                                validated = false;
                            }
                        default:
                            break;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 1: // Validar "total_socios"
                errs = datosFormulario.total_socios.socios.map((socios, index) => {
                    if (!socios.figura_juridica || !socios.n_empresas || !socios.n_personas) {
                        validated = false;
                        message.push(`Por favor completa todos los datos para el socio #${index + 1}.`);
                        return `socios_${index}`;
                    }
                });
                if (datosFormulario.total_socios.imagenes.length > 20) {
                    validated = false;
                    message.push('Solo se pueden subir un máximo de 20 imágenes.');
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 2: // Validar "antecedentes"
                errs = Object.keys(datosFormulario.antecedentes).map((label) => {
                    switch (label) {
                        case 'fecha_lugar': case 'origen': case 'year_inicio':
                            let v = datosFormulario.antecedentes[label];
                            if (!v || [null, '', undefined].includes(v)) {
                                validated = false;
                                return label;
                            }
                            break;
                        case 'imagenes':
                            if (datosFormulario.antecedentes.imagenes.length > 3) {
                                validated = false;
                                message.push('Solo se pueden subir un máximo de 3 imágenes.');
                            }
                            break;
                        default:
                            break;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 3: // Validar "objetivos e impactos"
                errs = Object.keys(datosFormulario.objetivos).map((label) => {
                    if (!datosFormulario.objetivos[label] || ['', null, undefined].includes(datosFormulario.objetivos[label])) {
                        validated = false;
                        message.push('Por favor completa todos los campos de los objetivos e impactos.');
                        return label;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 4: // Validar "funciones_servicios"
                errs = datosFormulario.funciones_servicios.actividades.map((actividad, index) => {
                    if (!actividad.nombre || !actividad.n_empresas || !actividad.n_socios) {
                        validated = false;
                        message.push(`Por favor completa todos los datos para la actividad #${index + 1}.`);
                        return `actividad_${index}`;
                    }
                    // if (actividad.imagenes.length > 2) {
                    if (datosFormulario.funciones_servicios.imagenes.filter((i) => i.index == index).length > 2) {
                        validated = false;
                        message.push(`La actividad #${index + 1} solo puede tener un máximo de 2 imágenes.`);
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 5: // Validar "actividades_economicas"
                errs = datosFormulario.actividades_economicas.actividades.map((actividad, index) => {
                    if (!actividad.giro) {
                        validated = false;
                        message.push(`Por favor selecciona un giro para la actividad económica #${index + 1}.`);
                        return `actividad_economica_${index}`;
                    }
                });
                if (datosFormulario.actividades_economicas.imagenes.length > 7) {
                    validated = false;
                    message.push('Solo se pueden subir un máximo de 7 imágenes.');
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;

            case 6: // Validar "datos_publicador"
                errs = Object.keys(datosFormulario.datos_publicador).map((label) => {
                    switch (label) {
                        case 'nombre': case 'email':
                            let valor = datosFormulario.datos_publicador[label];
                            if (!valor || [null, undefined, ''].includes(valor)) {
                                validated = false;
                                return label;
                            }
                            break;
                        case 'email':
                            if (!validarEmail(datosFormulario.datos_publicador.email)) {
                                validated = false;
                                message.push('Formato de correo electrónico incorrecto.');
                                return label;
                            }
                            break;
                        default:
                            break;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;

            default:
                break;
        }
        return { success: validated, messages: message };
    }



    // para guardar los datos en la bd (una vez completos)
    const handleSubmit = async () => {
        var formData = new FormData();
        construirFormData(formData, datosFormulario);
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/agregar_organismo`, { method: 'POST', body: formData })
            .then((res) => res.json())
            .then(respuesta => {
                toast[respuesta.status](respuesta.message);
                if (respuesta.status === "success") {
                    setTimeout(() => {
                        //navigate('/organismos');
                    }, 1000);
                }

            });
    }

    useEffect(() => { setErrores([]) }, [])

    const steps = [
        { id: 0, name: 'datos_generales', label: 'Datos Generales', action: <DatosGenerales datos={datosFormulario.datos_generales} setDatos={setDatos} errores={errores} isOrganismo /> },
        { id: 1, name: 'total_socios', label: 'Total Socios', action: <SociosOrganismo data={datosFormulario.total_socios} setDatos={setDatos} errores={errores} /> },
        { id: 2, name: 'antecedentes', label: 'Antecedentes de la Organización', action: <AntecedentesOrganismo data={datosFormulario.antecedentes} setDatos={setDatos} errores={errores} /> },
        { id: 3, name: 'objetivos', label: 'Objetivos e impactos de la Organización', action: <ObjetivosOrganismo data={datosFormulario.objetivos} setDatos={setDatos} errores={errores} /> },
        { id: 4, name: 'funciones_servicios', label: 'Funciones y servicios de la Organización', action: <FuncionesOrganismo data={datosFormulario.funciones_servicios} setDatos={setDatos} errores={errores} /> },
        { id: 5, name: 'actividades_economicas', label: 'Actividades económicas de la Organización', action: <ActividadesOrganismo data={datosFormulario.actividades_economicas} setDatos={setDatos} errores={errores} /> },
        { id: 6, name: 'datos_publicador', label: 'Datos del publicador', action: <DatosPublicador setCheck={setTerminos} datos={datosFormulario.datos_publicador} setDatos={setDatos} errores={errores} /> },
    ];

    const handleNextStep = () => {
        let validated = validar();
        if (validated.success) {
            setPaso(paso + 1);
        } else {
            //validated.messages.forEach((message) => {
            toast.error(validated.messages[0]);
            //})
            //console.log(errores);
        }
        window.scrollTo(0, 0);

    }

    const [open, setOpen] = useState(false);


    const validarPublicador = () => {
        let mail = datosFormulario.datos_publicador.email;
        if (['', null, undefined].includes(mail) || !validarEmail(mail)) {
            toast.error("Formato de correo electrónico incorrecto");
        } else {
            setOpen(false);
            setPaso(paso + 1);
        }
    }

    useEffect(() => console.log(datosFormulario), [datosFormulario]);

    return (
        <Box sx={{ mx: 'auto', mt: 0, width: '100%' }}>

            {/* Formulario */}
            <CardHeader title={<Typography textAlign='center' variant='h5'>
                Nuevo Organismo del sector de empresas y organizaciones sociales
                <Paper
                    square
                    elevation={0}
                    sx={{
                        display: { lg: 'none', xs: 'flex' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 50,
                        bgcolor: 'background.default',
                    }}
                >
                    <Typography textAlign='center' fontWeight='bold' color="primary" variant="h6">- {paso !== steps.length ? steps[paso].label : 'Registrar Empresa'} -</Typography>
                </Paper>
            </Typography>} />
            <Divider />
            <CardContent>
                {/* Stepper PC */}
                <Box sx={{ mt: 2, mb: 4, display: { xs: 'none', lg: 'block' } }}>
                    <Stepper activeStep={paso} orientation='horizontal'>
                        {steps.map((step, index) => {
                            return (
                                <Step key={step.label}>
                                    <StepLabel sx={{ '& :hover': { cursor: 'auto' } }} onClick={() => { setPaso(index) }}>{step.label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Box>
                {/* Pasos Movil */}

                <Grid spacing={1} container>
                    <Grid item md>
                        {paso === steps.length ? (
                            <Box sx={{ mx: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CheckCircle sx={{ fontSize: 100, color: '#a9f07f' }} />
                                </Box>
                                <Typography textAlign='center' variant="h6" sx={{ mt: 2, mb: 1 }}>
                                    <strong>¡Haz llegado al final!</strong><br />
                                    Si los datos son correctos, por favor haga clic en el botón para guardar el perfil de empresa.
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ mx: 2 }}>
                                {steps[paso].action}
                            </Box>
                        )}
                    </Grid>

                </Grid>
            </CardContent>
            {/* Navegacion pc */}

            <CardActions sx={{ display: { lg: 'flex', xs: 'none' }, justifyContent: 'space-around', my: 2 }}>
                {
                    paso !== steps.length ?
                        <React.Fragment>
                            <Button size='large' disabled={paso === 0} variant='contained' color="primary" onClick={() => setPaso(paso - 1)}>
                                Anterior
                            </Button>
                            {paso < steps.length - 1 &&
                                <Button disabled={paso === steps.length - 1 && !terminos} size='large' variant='contained' color="success" onClick={() => {
                                    let v = validar();
                                    if (v.success) {
                                        setPaso(steps.length - 1);
                                    } else {
                                        toast.error(v.messages[0]);
                                    }
                                }}>
                                    Guardar empresa
                                </Button>
                            }
                            <Button disabled={paso === steps.length - 1 && !terminos} size='large' variant='contained' color="success" onClick={handleNextStep}>
                                Siguiente
                            </Button>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Button size='large' variant='contained' color="primary" onClick={() => setPaso(paso - 1)}>
                                Anterior
                            </Button>
                            <Button size="large" color="success" variant="contained" onClick={handleSubmit}>GUARDAR EMPRESA</Button>
                        </React.Fragment>
                }
            </CardActions>
            {/* Stepper movil */}
            <Box sx={{ display: { lg: 'none', sx: 'block' } }}>
                <MobileStepper
                    variant="dots"
                    steps={steps.length}
                    position="bottom"
                    activeStep={paso}
                    backButton={
                        <Button size="small" onClick={() => setPaso(paso - 1)} disabled={paso === 0}>
                            <KeyboardArrowLeft />
                            Anterior
                        </Button>
                    }
                    nextButton={
                        <Button
                            size="small"
                            onClick={() => {
                                if (paso === steps.length) {
                                    handleSubmit();
                                } else {
                                    handleNextStep();
                                }
                            }
                            }
                            disabled={paso === steps.length - 1 && !terminos}
                            color={paso === steps.length ? 'success' : 'primary'}
                        >
                            {paso === steps.length ? 'Guardar' : 'Siguiente'}
                            <KeyboardArrowRight />
                        </Button>
                    }
                />

            </Box>

            {/* Modal para agregar correo electronico del usuario que publica */}
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>
                    <Typography variant="h5">
                        Agregar correo electrónico
                    </Typography>
                </DialogTitle>
                <Box sx={{ mx: 4 }}>
                    <Typography>Para poder editar este registro, necesitarás tu correo electrónico</Typography>
                    <TextField name="email" value={datosFormulario.datos_publicador.email} onChange={setDatos} sx={{ my: 2 }} fullWidth label="Correo electrónico" />
                </Box>
                <DialogActions>
                    <Button color="success" variant="contained" onClick={validarPublicador}>Guardar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default AgregarOrganismo